<template>
	<div class="notifications-view">
		<div class="wrapper-buttons">
			<div @click="redirectToTicket" class="button-description">
				<div class="header-button">
					<img :alt="getString('open_ticket')" :src="'https://img.qromo.io/img/icons/Icon-ticket-outline'+(userStore.darkMode ? '-dark' : '')+'.svg'"/>
					<div class="title-button">
						<p>{{ getString('open_ticket') }}</p>
					</div>
				</div>
				<p class="description">{{ getString('description_button_ticket') }}</p>
			</div>
			<div @click="redirectToHelpDesk" class="button-description">
				<div class="header-button">
					<img :alt="getString('open_ticket')" :src="'https://img.qromo.io/img/icons/Icon-wiky'+(userStore.darkMode ? '-dark' : '')+'.svg'"/>
					<div class="title-button">
						<p>{{ getString('show_wiki') }}</p>
					</div>
				</div>
				<p class="description">{{ getString('description_button_wiky') }}</p>
			</div>
		</div>
		<div class="wrapper-banner-invite">
			<div class="title-container">
				<div class="centered" v-html="svgStore.get('iconPresent')"></div>
				<p>{{ getString('referral_claim') }}</p>
			</div>
			<div class="row-invite-friend">
				<AppCard no-header inset class="card-background">
					<template #body>
						<AppButton @click="" style="width: 100%" :text="getString('invite_friend')"/>
					</template>
				</AppCard>
				<AppList class="instructions-list" :items="instructionsListItems">
					<template v-slot:instruction="{item}">
						<div class="row">
							<div class="icon-container" v-html="svgStore.get(item.icon)"></div>
							<div class="text-container">
								<div class="list-item-header">{{ item.title }}</div>
								<div class="extra-text">{{item.subtitle}}</div>
							</div>
						</div>
					</template>
				</AppList>
			</div>
		</div>
	</div>
</template>

<script>
import {useLanguageStore, useSvgStore} from "@/shared/stores";
import {useUserStore} from "@/user/stores";
import AppList from "@/shared/components/AppList.vue";
import AppCard from "@/shared/components/AppCard.vue";
import AppButton from "@/shared/components/AppButton.vue";

export default {
	components: {AppButton, AppCard, AppList},
	setup () {
		let languageStore = useLanguageStore();
		let userStore = useUserStore();
		const svgStore = useSvgStore();
		return {getString: languageStore.getString, userStore, svgStore}
	},
	name: "NotificationsView",
	computed: {
		instructionsListItems() {
			return [
				{customSlot: "instruction", icon: 'link', title: this.getString('referral_title_1'), subtitle: this.getString('referral_text_1')},
				{customSlot: "instruction", icon: 'iconPayments', title: this.getString('referral_title_2'), subtitle: this.getString('referral_text_2')},
				{customSlot: "instruction", icon: 'iconPresent', title: this.getString('referral_title_3'), subtitle: this.getString('referral_text_3')},
			]
		},
	},
}
</script>

<style scoped lang="scss">
	.notifications-view {
		display: flex;
		flex-direction: column;
		gap: 40px;
		.wrapper-buttons {
			display: flex;
			width: 100%;
			justify-content: space-between;
			gap: 20px;
			flex-wrap: wrap;
			@media screen and (max-width: 560px) {
				gap: 10px;
			}
			.button-description {
				display: flex;
				flex-direction: column;
				gap: 10px;
				width: calc(50% - 10px);
				padding: 20px;
				background-color: var(--color-alpha-1);
				border-radius: 26px;
				cursor: pointer;
				transition: background-color 0.3s $transition;
				@media screen and (max-width: 560px) {
					width: calc(50% - 5px);
					padding: 10px;
					border-radius: 13px;
				}
				@media screen and (max-width: 450px) {
					width: 100%;
					padding: 20px;
					border-radius: 26px;
				}
				.header-button {
					display: flex;
					align-items: center;
					gap: 10px;
					img {
						width: 15px;
						height: 15px;
					}
					.title-button {
						p {
							font-weight: 600;
							font-size: 18px;
							color: var(--color-primary);
							@media screen and (max-width: 560px) {
								font-size: 16px;
							}
						}
					}
				}
				p.description {
					font-weight: 400;
					font-size: 14px;
					color: var(--color-text-2);
					@media screen and (max-width: 560px) {
						font-size: 12px;
					}
				}
				&:hover {
					background-color: var(--color-alpha-2);
				}
			}
		}
		.wrapper-banner-invite {
			display: flex;
			flex-direction: column;
			gap: 10px;
			.title-container {
				display: flex;
				align-items: center;
				justify-content: center;
				margin-bottom: 10px;

				:deep(svg) {
					.stroke { stroke: var(--txt-0);	}
				}

				p {
					font-size: 20px;
					margin-left: 10px;
					font-weight: 600;
					line-height: normal;
				}
			}
			.row-invite-friend {
				display: flex;
				gap: 20px;
				@media screen and (max-width: 620px) {
					flex-direction: column-reverse;
				}
				.instructions-list {
					width: calc(50% - 10px);
					background-color: var(--color-alpha-1);
					border-radius: 26px;
					padding: 10px;
					@media screen and (max-width: 620px) {
						width: 100%;
					}
					:deep(.list-item) {
						padding-left: 0;

						&:after {
							display: none;
						}
					}

					.list-item-header {
						font-size: 16px;
						font-weight: 700;
					}
					.extra-text {
						font-size: 14px;
						color: var(--color-txt-1);
					}

					.icon-container {
						@include centered();
						width: 50px;
						:deep(svg) {
							width: 20px;
							height: 20px;
							.fill { fill: var(--txt-0);	}
							.stroke { stroke: var(--txt-0);	}
						}
					}

					.text-container {
						width: calc(100% - 50px);
					}
				}
				.card-background {
					display: flex;
					flex-direction: column;
					justify-content: flex-end;
					width: calc(50% - 10px);
					background-color: var(--color-bg);
					background-image: url(https://img.qromo.io/img/referral-card-background-min.png);
					background-repeat: no-repeat;
					background-position: center;
					background-size: cover;
					box-shadow: 1px 3px 4px 0px var(--color-box-shadow-3) inset;
					border-radius: 26px;
					min-height: 220px;
					overflow: hidden;
					padding: 10px;
					:deep(.card-body) {
						display: flex;
						justify-content: center;
						align-items: flex-end;
						width: 100%;
						height: fit-content;
						backdrop-filter: blur(12px);
						-webkit-backdrop-filter: blur(12px);
						background-color: var(--color-alpha-2);
						box-shadow: -1px -1px 2px 0px rgba(7, 16, 32, .3) inset, 1px 1px 2px 0px hsla(0, 0%, 100%, .4) inset;
						border-radius: 13px;
						overflow: hidden;
						.base-button {
							max-width: 250px;
							min-height: 40px;
						}
					}
					@media screen and (max-width: 620px) {
						width: 100%;
					}
				}
			}
		}
	}
</style>